import { createStyles, makeStyles } from '@mui/styles';
import { Colors } from '../../../layout/theme-next';
import { NextTheme } from '../../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>((theme) =>
  createStyles({
    root: {
      overflow: 'auto',
      margin: theme.spacing(1),
    },
    mt8: {
      marginTop: theme.spacing(1),
    },
    submitButton: {
      '&:hover': {
        backgroundColor: Colors.darkBluish,
      },
    },
  }),
);
